
import { getLocale } from "@/data/regionInfo";

export default {
  computed: {
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    defaultRecipe() {
      return this.$store.state.recipe.defaultRecipe;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    }
  },
  methods: {
    finishMyDesign() {
      this.setLoading(true);
      const changedSwatches = this.getChangedSwatches();
      const locale = getLocale();
      this.$store.dispatch('finishMyDesign/FINISH_MY_DESIGN', { locale, changedSwatches, recipeJSON: this.recipe_v2  } )
        .then(recipeJSON => {
          this.$store.commit("recipe/SET_RECIPE_V2", recipeJSON);
          this.setSwatchesSelectedFromRecipe(this.recipe_v2);
          this.$store.commit('ugc/tempData/SET_RECIPE', recipeJSON);
          this.applySwatches(recipeJSON);
          this.$store.dispatch("buyPanel/GET_PRICE", { recipe: this.recipe_v2});
        }).catch((err) => {
          console.log("Error getting finsihed recipe", err);
          this.setLoading(false);
        });
    },
    getChangedSwatches() {
      const { components: recipeV2Components } = this.recipe_v2;
      const { components: recipeDefaultComponents } = this.defaultRecipe;
      const components = {};

      for (let item in recipeV2Components) {
        if (recipeDefaultComponents[item] && recipeDefaultComponents[item].swatch_id !== recipeV2Components[item].swatch_id) {
          if (!this.$recipe.checkForUGCComponent(item)) {
            components[item] = recipeV2Components[item].swatch_id;
          }
        }
      }
      return components;
    },
    applySwatches(recipe) {
      new Promise((resolve, reject) => {
        this.$eventBus.$emit('apply-recipe', { recipe, resolve, reject });
      }).then(() => {
        this.setLoading(false);
      });
    },

    setLoading(status){
      this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'finishMyDesign', status });
      this.$store.commit("finishMyDesign/SET_LOADING_FINISH_MY_DESIGN", { isLoadingFinishMyDesign: status });
      this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'swatches', status });
    }
  }
};